import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Code2, Sparkles } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { name: 'Home', path: '/', icon: Sparkles },
    { name: 'Projects', path: '/projects', icon: Code2 },
    { name: 'Blog', path: '/blog', icon: Menu },
  ];

  return (
    <nav className="bg-white border-b-4 border-black fixed top-0 left-0 right-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-black">Blake Blaze</span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-3">
            {navItems.map((item, index) => {
              const colors = ['#E53935', '#1E88E5', '#FBC02D']; // Red, Blue, Yellow
              const color = colors[index % colors.length];
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`px-5 py-2 font-bold border-2 border-black transition-all duration-200 ${
                    isActive(item.path)
                      ? 'text-white'
                      : 'text-black bg-white hover:bg-gray-50'
                  }`}
                  style={isActive(item.path) ? { backgroundColor: color } : {}}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-black p-2"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-white border-t-2 border-black">
          <div className="px-2 pt-2 pb-3 space-y-2">
            {navItems.map((item, index) => {
              const colors = ['#E53935', '#1E88E5', '#FBC02D'];
              const color = colors[index % colors.length];
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-4 py-2 font-bold border-2 border-black transition-all duration-200 ${
                    isActive(item.path)
                      ? 'text-white'
                      : 'text-black bg-white hover:bg-gray-50'
                  }`}
                  style={isActive(item.path) ? { backgroundColor: color } : {}}
                >
                  {item.name}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
